import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { OrdemServicoNavigationService} from "../../shared/ordem-servico-navigation.service";
import { UtilService} from "../../../../shared/services/util.service";
import { editRoute, newRoute} from "../../../../shared/services/data.service";
import {ordensServicoModuleName, ordensServicoItemsStorage} from "../../shared/data.service";
import { MedidaApiService} from "../../../../almoxarifado/medidas/shared/medida-api.service";
import { OrdemServicoApiService} from "../../shared/ordem-servico-api.service";
import { isNumeric} from "rxjs/util/isNumeric";
import { OrdemServicoService} from "../../shared/ordem-servico.service";
import { ServicoApiService} from "../../../servicos/shared/servico-api.service";
import { OrdemServico} from "../../shared/ordem-servico.model";
import { MaterialOrdemServicoApiService} from "../../../../almoxarifado/materiais/materiais-ordem-servico/shared/material-ordem-servico-api.service";
import {servicosQuery, servicosStorage} from "../../../servicos/shared/data.service";
import {materiaisQuery, materialStorageName} from "../../../../almoxarifado/materiais/material/shared/data.service";
import {MaterialService} from "../../../../almoxarifado/materiais/material/shared/material.service";
import {AutoCompleteService} from "../../../../shared/components/autocomplete/autocomplete.service";
import {ServicoNavigationService} from "../../../servicos/shared/servico-navigation.service";
import {MaterialServicoApiService} from "../../../../almoxarifado/materiais/material-servico/shared/material-servico-api.service";

@Component({
    template: require('./ordem-servico-item-form.component.html'),
    styles: [require('./ordem-servico-item-form.component.css')]
})
export class OrdemServicoItemFormComponent implements OnInit {
    ordemServicoModuleName: any = ordensServicoModuleName;
    itemComponentName: any = 'item';
    formObject: any = {};
    ordemServicoObject: OrdemServico = new OrdemServico();
    actionTitle: string;
    submitted: boolean = false;
    btnSaveDisabled: boolean = false;
    isService: boolean = false;

    servicomaterialObject: any = {};
    unidadeObject: any = {};
    materiaisServicesList: any[] = [];
    medidasList: any[] = [];
    total: string = '';
    materialLimitQnt: number = 0;
    materiaisServicosSelectId: string;
    materiaisServicosQuery: any;

    form: FormGroup;
    servicomaterial = new FormControl('', Validators.required);
    ativo = new FormControl('');
    data = new FormControl('', Validators.required);
    quantidade = new FormControl('', Validators.required);
    medida = new FormControl('', Validators.required);
    valor = new FormControl('', Validators.required);
    valorTotal = new FormControl({value: '', disabled: true}, Validators.required);

    private responseServico: any;
    private isSubMaterial: boolean = false;

    constructor(
        private _route: ActivatedRoute,
        private _ordemServicoNavigationService: OrdemServicoNavigationService,
        private _ordemServicoApiService: OrdemServicoApiService,
        private _medidaApiService: MedidaApiService,
        private _ordemServicoService: OrdemServicoService,
        private _servicoApiService: ServicoApiService,
        private _materialOrdemServicoApiService: MaterialOrdemServicoApiService,
        private _autocompleteService: AutoCompleteService,
        private _servicoNavigationService: ServicoNavigationService,
        private _materialService: MaterialService,
        private _utilService: UtilService,
        private _materialServicoApiService: MaterialServicoApiService,
        private _fb: FormBuilder
    ) {
        this.form = _fb.group({
            ativo: this.ativo,
            servicomaterial: this.servicomaterial,
            data: this.data,
            quantidade: this.quantidade,
            medida: this.medida,
            valor: this.valor,
            valorTotal: this.valorTotal
        });
    }

    ngOnInit() {
        this.getOrdemServico();

        let tipo = +this._route.snapshot.params['tipo'];
        let tipoServico = this._ordemServicoService.getItemTipoServico();

        if (tipo === tipoServico.Key) {
            this.materiaisServicosQuery = servicosQuery;
            this.isService = true;
            this.materiaisServicosSelectId = 'servicos';
        } else {
            this.getMedidas();
            this.materiaisServicosQuery = materiaisQuery;
            this.materiaisServicosSelectId = 'materiais';
        }

        this.testSession();
    }

    clickGoToList() {
        this.goToList();
    }

    clickGoToDetail() {
        this.goToDetail();
    }

    clickCancel() {
        this.goToDetail();
    }

    keyupCurrency(start?: boolean) {
        const valor: number = this._utilService.currencyFormat(this.formObject.valor, start);
        if (valor) {
            this.formObject.valor = valor;
        }
        this.calculateTotal();
    }

    keyupQuantidade() {
        if (this.materialLimitQnt && (this.formObject.quantidade > this.materialLimitQnt)) {
            this.formObject.quantidade = 1;
        }
        this.calculateTotal();
    }

    onSubmit(evt: any) {
        this.submitted = true;

        if (this.isService) {
            this._utilService.setSelectOnFormControl(this.form, 'medida', {id: -1});
        } else {
            this._utilService.setSelectOnFormControl(this.form, 'data', {id: -1});
        }

        if (this.formObject.valor == 0 || this.formObject.valor === '0,00') {
            return false;
        }

        if(evt.valid) {
            this.btnSaveDisabled = true;
            let object:any = this._utilService.cloneObject(this.formObject);

            if (this.total) {
                object.valor = this._utilService.getCurrency(this.total);
            }

            object.descricao = this.servicomaterialObject.descricao;

            if (this.isService) {
                //servico
                let date: any = document.getElementById('data');
                if (date.value) {
                    object.data = this._utilService.convertStringToDate(date.value);
                } else {
                    object.data = null;
                }

                delete object['unidade'];
                object.servicoId = this.servicomaterialObject.id;
            } else {
                //material
                if (this.unidadeObject.id) {
                    object.medidaId = this.unidadeObject.id;
                }
                delete object['data'];
                object.materialId = this.servicomaterialObject.id;
            }

            object.ordemServicoId = this.ordemServicoObject.id;

            if (this.formObject.id) {
                this.onEditServico(object);
            } else {
                this.onAddServico(object);
            }
        }
    }

    getMateriaisServicosObject(object: any) {
        if (object.novo) {
            let thisFormObject:any = this.setObjectBeforeLeave();

            this._ordemServicoService.setItemsSessionStorage(thisFormObject);
            let toOtherFormObject: any = {
                descricao: object.text,
                form: ordensServicoItemsStorage
            };
            if (this.isService) {
                this._autocompleteService.setSessionStorage(toOtherFormObject, servicosStorage);
                this._servicoNavigationService.goToNew();
            } else {
                this._autocompleteService.setSessionStorage(toOtherFormObject, materialStorageName);
                this._materialService.goToAdd();
            }
        } else {
            this.servicomaterialObject = object;
            this._utilService.setSelectOnFormControl(this.form, 'servicomaterial', object);

            if (!this.isService) {
                this.setMedidaOnMaterial(this.servicomaterialObject.medidaId);
            }

            if (this.servicomaterialObject.valor) {
                this.formObject.valor = this.servicomaterialObject.valor;
                this.keyupCurrency(true);
            }
        }
    }

    materiaisServicosTemplateResult = (function(state: any) {
        return this._ordemServicoService.templateResult(state, true);
    }.bind(this));

    private setObjectBeforeLeave() {
        let object: any = this.formObject;
        object.tipo = +this._route.snapshot.params['tipo'];
        object.osId = +this._route.snapshot.params['osId'];
        object.valor = this.total;
        if (this.isService) {
            object.servico = this.servicomaterialObject;
        } else {
            object.material = this.servicomaterialObject;
            object.medidaId = this.unidadeObject.id;
        }

        return object;
    }

    private onAddServico(object: any) {
        if (this.isService) {
            this._servicoApiService.onPostServicoOrdemServico(object, this.onDone);
        } else {
            this._materialOrdemServicoApiService.onPostMaterialOrdemServico(object, this.onDone);
        }
    }

    private onEditServico(object: any) {
        if (this.isService) {
            this._servicoApiService.onPutServicoOrdemServico(object, this.onDone);
        } else {
            this._materialOrdemServicoApiService.onPutMaterialOrdemServico(object, this.onDone);
        }
    }

    private onDone = (function (Response: any) {
        if (!Response.error) {
            this.responseServico = Response;

            if (this.formObject.id) {
                this._utilService.swalMessageEditSuccess();
            } else {
                this._utilService.swalMessageAddSuccess();
            }

            if (this.isService) {
                this.getMateriaisServico();
            } else {
                this.toLeaveHere();
            }
        } else {
            this.btnSaveDisabled = false;
            this._utilService.swalMessageWarningCustom(Response.error);
        }
    }.bind(this));

    private getObject(id: number) {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.formObject = Response;
                this.setModelToForm();
            } else {
                this._utilService.swalMessageWarningCustom('Nenhum material/serviço encontrado com este id.');
                this.toLeaveHere();
            }
        }.bind(this));

        let tipo = +this._route.snapshot.params['tipo'];
        let serviceType: any = this._ordemServicoService.getItemTipoServico();
        if (tipo === serviceType.Key) {
            this._servicoApiService.onGetByIdServicoOrdemServico(id, onDone);
        } else {
            this._materialOrdemServicoApiService.onGetByIdMaterialOrdemServico(id, onDone);
        }
    }

    private getMateriaisServico() {
        const onDone2 = (function(Response: any) {
            this.toLeaveHere();
        }.bind(this));

        const onDone = (function(Response: any) {
            if (!Response.error)  {
                if (Response.length === 0) {
                    this.toLeaveHere();
                } else {
                    this.isSubMaterial = true;
                    var list: any[] = [];
                    Response.forEach(function(item: any){
                        if (item.material) {
                            list.push({
                                descricao: item.material.descricao,
                                quantidade: item.quantidade,
                                medidaId: item.material.medidaId,
                                materialId: item.material.id,
                                ordemServicoId: this.ordemServicoObject.id,
                                ativo: true
                            });
                        }
                    }.bind(this));

                    this._materialOrdemServicoApiService.onPostMateriaisOrdemServico(list, onDone2);
                }
            }
        }.bind(this));

        this._materialServicoApiService.onGetByServico(this.servicomaterialObject.id, onDone);
    }

    private testSession() {
        let id: number;
        let session: any = this._ordemServicoService.getItemsSessionStorage();
        this._ordemServicoService.clearItemsSessionStorage();

        if (session) {
            this.formObject = session;
            id = session.id;
            setTimeout(function() {
                this.setModelToForm();
            }.bind(this));

        } else {
            id = +this._route.snapshot.params['id'];
            if (id) {
                this.setEditNormal(id);
            } else {
                this.setNewNormal();
            }
        }

        this.setActionTitle(id);
    }

    private setModelToForm() {
        let valor: any = 0, qnt: any = 0;

        if (this.formObject.data && (this.formObject.data.indexOf("/") === -1)) {
            this.formObject.data = this._utilService.convertDateToString(this.formObject.data);
        }

        if (this.formObject.quantidade && (this.formObject.quantidade !== undefined)) {
            qnt = this.formObject.quantidade;
        }

        if (this.formObject.valor && (this.formObject.valor !== '0,00')) {
            valor = this._utilService.getCurrency(this.formObject.valor);
        } else {
            if (this.formObject.servico) {
                valor = this.formObject.servico.valor;
            }
        }

        this.formObject.valor = (valor / qnt || 0).toFixed(2);
        this.calculateTotal();
        this.keyupCurrency(true);

        if (this.formObject.servico) {
            this.isService = true;

            this.servicomaterialObject = this._utilService.cloneObject(this.formObject.servico);
            delete this.formObject['servico'];
        }

        if (this.formObject.material) {
            this.isService = false;

            this.servicomaterialObject = this._utilService.cloneObject(this.formObject.material);
            delete this.formObject['material'];

            if (this.formObject.medidaId) {
                this.unidadeObject = {id: this.formObject.medidaId};
                this.setMedidaOnMaterial(this.formObject.medidaId);
                delete this.formObject['medida'];
            }
        }

        if (this.servicomaterialObject) {
            let selectObject:any = {text: this.servicomaterialObject.descricao, id: this.servicomaterialObject.id};

            this._autocompleteService.createOptionOnSelect2(this.materiaisServicosSelectId, selectObject);
            this._autocompleteService.setValueOnSelect2(selectObject.id, this.materiaisServicosSelectId);
            this._utilService.setSelectOnFormControl(this.form, 'servicomaterial', this.servicomaterialObject);
        }
    }

    private toLeaveHere() {
        this.goToDetail();
    }

    private goToList() {
        this._ordemServicoNavigationService.goToList();
    }

    private goToDetail() {
        this._ordemServicoNavigationService.goToDetail(this.ordemServicoObject.id);
    }

    private setActionTitle(id: number) {
        if (id) {
            this.actionTitle = editRoute;
        } else {
            this.actionTitle = newRoute;
        }
    }

    private setEditNormal(id: number) {
        this.getObject(id);
    }

    private setNewNormal() {
        if (this.isService) {
            this.formObject.data = this._utilService.convertDateToString(new Date());
        }
    }

    private getOrdemServico() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                this.ordemServicoObject = Response;
            } else {
                this._utilService.swalMessageWarningCustom('Nenhuma manutenção encontrada com este id.');
                this.clickGoToDetail();
            }
        }.bind(this));

        let osId = +this._route.snapshot.params['osId'];
        this._ordemServicoApiService.onGetById(osId, onDone);
    }

    private getMedidas() {
        const onDone = (function(Response: any) {
            if (!Response.error)  {
                let list: any[] = [],
                    x: number, lenX: number;
                for (x = 0, lenX = Response.length; x < lenX; x++) {
                    if (Response[x].ativo) {
                        list.push(Response[x]);
                    }
                }

                this.medidasList = list;
                if (this.unidadeObject.id) {
                    this.setMedidaOnMaterial(this.unidadeObject.id);
                }
            }
        }.bind(this));

        this._medidaApiService.onGetAll(onDone);
    }

    private setMedidaOnMaterial(medidaId: number) {
        let x: any, lenX: any;
        for (x = 0, lenX = this.medidasList.length; x < lenX; x++) {
            if (medidaId === this.medidasList[x].id) {
                this.unidadeObject = this.medidasList[x];
                break;
            }
        }
    }

    private calculateTotal() {
        if (!this.formObject.quantidade) {
            this.formObject.quantidade = 1;
        }

        if (!this.formObject.valor) {
            this.formObject.valor = 0;
        }

        let valor: any = this.formObject.valor;
        if (valor) {
            if(isNumeric(valor)) {
                valor = valor.toString();
            } else {
                valor = valor.replace(/\./g, "");
                valor = valor.replace(",", ".");
            }
        }
        valor = parseFloat(valor);

        if (!valor) valor = 0;
        valor = this.formObject.quantidade * valor;
        valor = valor.toFixed(2);
        this.total = this._utilService.currencyFormat(valor, true);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/ordens-servico/ordem-servico-item/ordem-servico-item-form/ordem-servico-item-form.component.ts
 **/